import React from 'react';

function HostLicenseIcon({ width = 19, height = 13, ...rest }) {
  return (
    <svg width={width} height={height} viewBox="0 0 19 13" {...rest}>
      <title>License icon</title>
      <g>
        <path d="M17,0 C18.1045695,-2.02906125e-16 19,0.8954305 19,2 L19,11 C19,12.1045695 18.1045695,13 17,13 L2,13 C0.8954305,13 1.3527075e-16,12.1045695 0,11 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L17,0 Z M5.43096473,7 L3.56818052,7.00023245 C2.64903983,7.31868898 2,8.09414226 2,9 L2,9 L7,9 C7,8.09367736 6.35067525,7.31822408 5.43096473,7 L5.43096473,7 Z M16,7 L9,7 L9,8 L16,8 L16,7 Z M4.49986089,4 C3.67161272,4 3,4.67155045 3,5.5 C3,6.32844955 3.67161272,7 4.49986089,7 C5.32838728,7 6,6.32844955 6,5.5 C6,4.67155045 5.32838728,4 4.49986089,4 Z M16,5 L9,5 L9,6 L16,6 L16,5 Z" />
      </g>
    </svg>
  );
}

export default HostLicenseIcon;
